import { useState, useEffect, useRef } from "react";

export default function TypewriterText({ text, animate = false, onComplete }) {
  const words = text.split(" ");
  const [revealed, setRevealed] = useState(animate ? words[0] : text);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!animate) return;
    let idx = 1;
    intervalRef.current = setInterval(() => {
      idx += 1;
      setRevealed(words.slice(0, idx).join(" "));
      if (idx >= words.length) {
        clearInterval(intervalRef.current);
        if (onComplete) onComplete();
      }
    }, 50);
    return () => clearInterval(intervalRef.current);
  }, [animate, text, onComplete]);

  const skip = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setRevealed(text);
      if (onComplete) onComplete();
    }
  };

  return (
    <span onClick={skip} style={{ cursor: animate && revealed !== text ? "pointer" : "text" }}>
      {animate ? revealed : text}
    </span>
  );
}
